<script>
  import domtoimage from "dom-to-image-more";
  import saveAs from "file-saver";
  import Button from "../UI/Button.svelte";
  import rosterStore from "./player-store.js";
  import team from "../config/teams.js";

  export let player = null;
  export let selfieCard = null;

  const isFavStorage = window.localStorage;
  let playerMetaPromise = null;
  let isFlipped = false;

  function toggleFavorite() {
    const updatedPlayer = { ...player };
    updatedPlayer.isFavorite = !updatedPlayer.isFavorite;

    isFavStorage.setItem(updatedPlayer.person.id, updatedPlayer.isFavorite);

    rosterStore.update(items => {
      const playerIndex = items.findIndex(
        p => p.person.id === player.person.id
      );
      const updatedRoster = [...items];
      updatedRoster[playerIndex] = updatedPlayer;

      return updatedRoster;
    });
  }

  function handleMouseOver() {
    playerMetaPromise = getPlayerData();
  }

  function handleClick() {
    isFlipped = !isFlipped;
  }

  async function getPlayerData() {
    if (!player) {
      return;
    }

    const playerId = player.person.id;

    // Coder exception – not part of NHL API!
    if (playerId === 1) {
      return;
    }

    const res = await fetch(
      `https://statsapi.web.nhl.com/api/v1/people/${playerId}`
    );
    const data = await res.json();

    if (res.ok) {
      const playerMeta = [...data.people][0];
      return playerMeta;
    } else {
      throw new Error(`Toronto, we have a problem. Sorry.`);
    }
  }

  function shareSelfieCard() {
    let card = document.getElementById("capture");
    let downloadIcon = document.querySelector(".icon-download");
    downloadIcon.style.visibility = "hidden";

    domtoimage
      .toBlob(card)
      .then(function(blob) {
        saveAs(blob, "selfie-card.png");
        downloadIcon.style.visibility = "visible";
      })
      .catch(function(error) {
        console.error("darn, something went wrong!", error);
      });
  }

  /* Player image src on nhlpa.com
  src={`https://cdn.nhlpa.com/img/assets/players/clipped-headshots/320/${player.person.photoId}.png`}
  */
</script>

<style lang="scss">
  @import "../style/theme-config.scss";

  .card {
    position: relative;
    width: 327px;
    height: 456px;
    margin: 0 auto;

    @media (min-width: 768px) {
      width: auto;
      height: 434px;
    }

    @media (min-width: 992px) {
      height: 370px;
    }

    @media (min-width: 1200px) {
      height: 455px;
    }
  }

  .card-portrait {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 42px;
    margin: 0 auto;
    width: 90%;

    @media (min-width: 768px) {
      bottom: 38px;
    }

    @media (min-width: 992px) {
      bottom: 36px;
    }

    @media (min-width: 1200px) {
      bottom: 40px;
    }
  }

  .card-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .bg-card {
    position: relative;
    max-width: 100%;
  }

  .player-name {
    position: absolute;
    left: 16px;
    bottom: 14px;
    margin: 0;
    line-height: 1;
    text-transform: uppercase;
    z-index: 1;

    @media (min-width: 768px) {
      left: 14px;
      bottom: 10px;
    }

    @media (min-width: 992px) {
      bottom: 8px;
    }

    @media (min-width: 1200px) {
      left: 16px;
      bottom: 14px;
    }
  }

  .player-firstname {
    font-size: 0.85rem;
    font-weight: 600;
    color: black;

    @media (min-width: 992px) {
      font-size: 0.75rem;
    }

    @media (min-width: 1200px) {
      font-size: 0.85rem;
    }
  }

  .player-lastname {
    font-size: 1.3rem;
    font-weight: 600;
    color: #ec352c;

    @media (min-width: 992px) {
      font-size: 1.1rem;
    }

    @media (min-width: 1200px) {
      font-size: 1.3rem;
    }
  }

  .player-position {
    position: absolute;
    right: 25px;
    bottom: 14px;
    margin: 0;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    z-index: 1;

    @media (min-width: 768px) {
      bottom: 12px;
    }

    @media (min-width: 992px) {
      bottom: 7px;
      font-size: 0.75rem;
    }

    @media (min-width: 1200px) {
      right: 25px;
      bottom: 14px;
      font-size: 0.8rem;
    }
  }

  .player-number {
    font-family: "NHLHockey", sans-serif;
    font-size: 14rem;
    color: white;
    text-shadow: $jersey-number-text-shadow;
    user-select: none;

    @media (min-width: 992px) {
      font-size: 10rem;
    }

    @media (min-width: 1200px) {
      font-size: 14rem;
    }
  }

  .flip-container {
    perspective: 1000;

    transform-style: preserve-3d;
    transform: rotateY(0deg);

    &:hover {
      .download {
        visibility: visible; // !important;
      }
    }
  }

  .flip-container,
  .front,
  .back {
    font-size: 1.25rem;
    width: 100%;
    height: 100%;
    line-height: 1.25;

    @media (min-width: 768px) {
      font-size: 1.1rem;
    }

    @media (min-width: 992px) {
      font-size: 0.95rem;
    }

    @media (min-width: 1200px) {
      font-size: 1.25rem;
    }
  }

  .flipper {
    transition: transform 0.6s;
    transform-style: preserve-3d;

    position: relative;

    .flip & {
      transform: rotateY(180deg);
    }
  }

  .front,
  .back {
    backface-visibility: hidden;

    transition: transform 0.6s;
    transform-style: preserve-3d;
    transform: rotateY(0deg);

    position: absolute;
    top: 0;
    left: 0;
  }

  .front {
    position: relative;
    transform: rotateY(0deg);

    background: $color-highlight;
    z-index: 2;
  }

  .back {
    background: $card-background;
    transform: rotateY(-180deg);

    text-align: center;
    color: white;
    padding: 40px;
  }

  .favorite {
    position: absolute;
    top: 0.7rem;
    right: 1rem;
    font-size: 3rem;
    color: $color-highlight;
    cursor: pointer;

    svg {
      width: 48px;
      height: 48px;
      fill: $color-highlight;
    }
  }

  .download {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    color: white;
    z-index: 102;
    visibility: hidden;
    user-select: none;

    svg {
      width: 132px;
      height: 132px;
      fill: white;
      opacity: 0.5;
      cursor: pointer;
    }
  }
</style>

<div
  class="flip-container"
  class:flip={isFlipped}
  ontouchstart="this.classList.toggle('hover');">
  {#if player}
    <div
      id="p-{player.person.id}"
      class="flipper card"
      on:mouseover|once={handleMouseOver}
      on:click={handleClick}>
      <div class="front card-body">
        {#if player.person.photoId === 1}
          <img
            class="card-portrait"
            src={`/images/players/1.png`}
            alt={`player.person.fullName`} />
        {:else if player.person.photoId === 0 || player.person.photoId === undefined}
          <img
            class="card-portrait"
            src={`https://cdn.nhlpa.com/img/assets/players/clipped-headshots/320/1.png`}
            alt={`player.person.fullName`} />
        {:else}
          <img
            class="card-portrait"
            src={`https://cdn.nhlpa.com/img/assets/players/clipped-headshots/320/${player.person.photoId}.png`}
            alt={`player.person.fullName`} />
        {/if}
        <p class="player-name">
          <span class="player-firstname">
            {player.person.firstName}
            <br />
          </span>
          <span class="player-lastname">{player.person.lastName}</span>
        </p>
        <p class="player-position">{player.position.name}</p>
        <img
          class="bg-card"
          src={`/images/cards/card-${team.id}-xpar.png`}
          alt="" />
      </div>
      <div class="back card-body">
        <h1 class="player-number">{player.jerseyNumber}</h1>
        <span class="favorite" on:click={toggleFavorite}>
          {#if player.isFavorite}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24px"
              height="24px">
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3
                7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3
                22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
            </svg>
          {:else}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24px"
              height="24px">
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42
                3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12
                21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5
                3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5
                7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2
                0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" />
            </svg>
          {/if}
        </span>

        {#await playerMetaPromise then playerMeta}
          {#if playerMeta}
            <p>
              {#if playerMeta.height}
                Height: {playerMeta.height}&nbsp;&nbsp;
              {/if}
              {#if playerMeta.weight}Weight: {playerMeta.weight}{/if}
            </p>
            <p>
              {#if playerMeta.birthDate}Born: {playerMeta.birthDate}{/if}
              <br />
              {#if playerMeta.birthCity}{playerMeta.birthCity},{/if}
              {#if playerMeta.birthStateProvince}
                {playerMeta.birthStateProvince},
              {/if}
              {#if playerMeta.birthCountry}{playerMeta.birthCountry}{/if}
            </p>
          {/if}
        {/await}
      </div>
    </div>
  {:else if selfieCard}
    <div
      id="selfie"
      class="flipper card"
      on:mouseover|once={handleMouseOver}
      on:click={handleClick}
      ontouchstart="this.classList.toggle('hover');">
      <div id="capture" class="front card-body">
        <img class="card-portrait" src={selfieCard.selfie} alt="" />
        <p class="player-name">
          {#if selfieCard.firstName}
            <span class="player-firstname">
              {selfieCard.firstName}
              <br />
            </span>
          {/if}
          {#if selfieCard.lastName}
            <span class="player-lastname">{selfieCard.lastName}</span>
          {/if}
        </p>
        <p class="player-position text-muted">{selfieCard.positionName}</p>
        <img
          class="bg-card"
          src={`/images/cards/card-${team.id}-xpar.png`}
          alt="" />
        <div class="download">
          <svg
            on:click={shareSelfieCard}
            class="icon-download"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            width="24px"
            height="24px">
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path
              d="M13 5v6h1.17L12 13.17 9.83 11H11V5h2m2-2H9v6H5l7 7 7-7h-4V3zm4
              15H5v2h14v-2z" />
          </svg>
        </div>
      </div>
      <div class="back card-body">
        <h1 class="player-number">
          {#if selfieCard.jerseyNumber}{selfieCard.jerseyNumber}{/if}
        </h1>
        <p>
          {#if selfieCard.height}Height: {selfieCard.height}&nbsp;&nbsp;{/if}
          {#if selfieCard.weight}Weight: {selfieCard.weight}{/if}
        </p>
        <p>
          {#if selfieCard.birthDate}Born: {selfieCard.birthDate}{/if}
          <br />
          {#if selfieCard.birthCity}{selfieCard.birthCity},{/if}
          {#if selfieCard.birthStateProvince}
            {selfieCard.birthStateProvince},
          {/if}
          {#if selfieCard.birthCountry}{selfieCard.birthCountry}{/if}
        </p>
      </div>
    </div>
  {/if}
</div>
